import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-save-discard-dialog',
  templateUrl: './save-discard-dialog.component.html',
  styleUrls: ['./save-discard-dialog.component.css']
})
export class SaveDiscardDialogComponent implements OnInit {

    constructor(
    public dialogRef: MatDialogRef<SaveDiscardDialogComponent>
    ){}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/sdg/save-discard-dialog/save-discard-dialog.component.ts